import React from 'react';
import { Linkedin, Mail } from 'lucide-react';

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const NewsShareButtons = ({ url, title }) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  const links = [
    { id: 'linkedin', label: 'Share on LinkedIn', Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}` },
    { id: 'x', label: 'Share on X', Icon: XIcon, href: `https://twitter.com/intent/tweet?url=${u}&text=${t}` },
    { id: 'email', label: 'Share by email', Icon: Mail, href: `mailto:?subject=${t}&body=${t}%0A%0A${u}` },
  ];
  return (
    <div className="flex items-center gap-2" data-testid="news-share-buttons">
      <span className="text-sm font-semibold text-slate-500 mr-1">Share</span>
      {links.map(({ id, label, Icon, href }) => (
        <a
          key={id}
          href={href}
          target={id === 'email' ? undefined : '_blank'}
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
          data-testid={`news-share-${id}`}
          className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-slate-200 text-slate-600 hover:bg-[#1e2d3b] hover:text-white hover:border-[#1e2d3b] transition-colors duration-200"
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
    </div>
  );
};

export default NewsShareButtons;
